var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-wrapper", class: _vm.classObj },
    [
      _vm.device === "mobile" && _vm.sidebar.opened
        ? _c("div", {
            staticClass: "drawer-bg",
            on: { click: _vm.handleClickOutside },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("sidebar", { staticClass: "sidebar-container" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "main-container",
          class: { hasTagsView: _vm.needTagsView },
        },
        [
          _c(
            "div",
            { class: { "fixed-header": _vm.fixedHeader } },
            [
              _c("navbar"),
              _vm._v(" "),
              _vm.needTagsView ? _c("tags-view") : _vm._e(),
              _vm._v(" "),
              _c("TimeBar"),
            ],
            1
          ),
          _vm._v(" "),
          _c("app-main"),
          _vm._v(" "),
          _vm.showSettings ? _c("right-panel", [_c("settings")], 1) : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [
        _c("div", [_vm._v("Version: " + _vm._s(_vm.versionDisplay))]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "©" +
              _vm._s(new Date().getFullYear()) +
              " Blue Planet Training, Inc. All rights reserved."
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              staticClass: "lh-footer-link",
              attrs: {
                href: "https://lifehikes.com/privacy-policy/",
                target: "_blank",
                rel: "noopener",
              },
            },
            [_vm._v("Privacy Policy")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "lh-footer-separator" }, [_vm._v("|")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "lh-footer-btn",
              attrs: { type: "button" },
              on: { click: _vm.openCookieSettings },
            },
            [_vm._v("Cookie Settings")]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }